module.exports = __webpack_public_path__ + "static/anna_before-30954dc81ff190d65fabb82d9c0c2757.jpg";